import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-simpler-select'
import ReactModal from 'react-modal'
import Nexus from 'nexusui'
import ReactTooltip from 'react-tooltip'
import isWindows from 'is-windows'

import Button from './UI/Button'

import curveTables from '../constants/curveTables.json'
import tooltips from '../constants/tooltips.json'

import {
  closeVelocityCurves,
  selectVelocityCurve,
  selectUserCurve,
  saveUserCurve,
} from '../actions'

const userCurveMenuItems = ['User Curve 1', 'User Curve 2', 'User Curve 3', 'User Curve 4']

class VelocityCurves extends Component {
  handleCloseModal = () => {
    this.props.onCloseVelocityCurves()
    this.props.onSelectVelocityCurve(-1)
    this.props.onSelectUserCurve(7)
    this.multislider.destroy()
   }

  afterOpenModal = () => {
    this.multislider = new Nexus.Multislider('#velocity-curves', {
     'size': [500,200],
     'numberOfSliders': 127,
     'min': 0,
     'max': 127,
     'step': 1,
     'values': this.props.userCurves['usercurve-0']
    })

    Nexus.colors.accent = "#04aef0"
    this.multislider.colorize("fill","#333")
    this.multislider.colorize("accent","#04aef0")

    ReactTooltip.rebuild()
  }

  render() {
    const {
      deviceConnected,
      velocityCurvesOpen,
      selectedVelocityCurve,
      selectedUserCurve,
      onSaveUserCurve,
      onSelectVelocityCurve,
      onSelectUserCurve,
      userCurves,
      showTooltips
    } = this.props
    return (
      <div className='velocity-curves-modal'>
        <ReactModal
          isOpen={velocityCurvesOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.handleCloseModal}
          shouldCloseOnOverlayClick={false}
          className="react-modal"
          overlayClassName="react-modal-overlay"
          contentLabel="Velocity Curves"
        >
          <div className='velocity-curves-editor'>
            <div
              className='velocity-curve-buttons'
              data-tip={tooltips['editor-velocity-curves-curves']}
              data-multiline="true"
              data-place="bottom"
              data-tip-disable={!showTooltips}
              >
              {Object.keys(curveTables).map((name, index) =>
                <Button
                  name={name}
                  key={name}
                  index={index}
                  value={name}
                  toggle={selectedVelocityCurve}
                  onClick={button => {
                    onSelectVelocityCurve(button.dataset.index)
                    this.multislider.setAllSliders([...curveTables[button.value]])
                  }} />
              )}
              <Button
                name='X'
                onClick={this.handleCloseModal}
                data-tip={tooltips['editor-velocity-curves-close']}
                data-multiline="true"
                data-place="bottom"
                data-tip-disable={!showTooltips}
              />
            </div>
            <div
              id='velocity-curves'
              data-tip={tooltips[`editor-velocity-curves-editor${isWindows() ? '-windows' : ''}`]}
              data-multiline="true"
              data-place="bottom"
              data-type={isWindows() ? "warning" : "light" }
              data-tip-disable={!showTooltips}
              ></div>
            <div className='user-curve-dialog'>
              <Select
                name="user-curve"
                value={selectedUserCurve}
                options={userCurveMenuItems.map((item, index) => ({label: item, value: index + 7}))}
                onChange={(index) => {
                  onSelectUserCurve(~~index)
                  this.multislider.setAllSliders([...userCurves['usercurve-' + (index - 7)]])
                }}
                data-tip={tooltips['editor-velocity-curves-user']}
                data-multiline="true"
                data-place="bottom"
                data-tip-disable={!showTooltips}
              />
              <Button
                name={'save & send'}
                onClick={() => onSaveUserCurve(selectedUserCurve-7, [...this.multislider.values])}
                disabled={!deviceConnected}
                data-tip={tooltips['editor-velocity-curves-user-save']}
                data-multiline="true"
                data-place="bottom"
                data-tip-disable={!showTooltips}
              />
              <Button
                name={'reset'}
                onClick={() => {
                  onSelectVelocityCurve(0)
                  this.multislider.setAllSliders([...curveTables.linear])}
                }
                data-tip={tooltips['editor-velocity-curves-user-reset']}
                data-multiline="true"
                data-place="bottom"
                data-tip-disable={!showTooltips}
              />
            </div>
          </div>
        </ReactModal>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deviceConnected: state.device.connected,
    velocityCurvesOpen: state.editor.velocityCurvesOpen,
    selectedVelocityCurve: state.editor.selectedVelocityCurve,
    selectedUserCurve: state.editor.selectedUserCurve,
    userCurves: state.userCurves,
    showTooltips: state.editorPreferences.showTooltips
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onCloseVelocityCurves: () => {
      dispatch(closeVelocityCurves())
    },
    onSelectVelocityCurve: (index) => {
      dispatch(selectVelocityCurve(~~index))
    },
    onSelectUserCurve: (index) => {
      dispatch(selectUserCurve(~~index))
    },
    onSaveUserCurve: (index, curve) => {
      dispatch(saveUserCurve(~~index, curve))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VelocityCurves)
